"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var pp_react_1 = require("@paypalcorp/pp-react");
var GetAddress = function (props) {
    var layout = props.layout;
    var address = "";
    return (React.createElement(pp_react_1.Text, { size: "md" }, layout &&
        layout.map(function (layoutItem) {
            if (layoutItem.$ === "linePost") {
                var lineItem = React.createElement("div", null, address);
                address = "";
                return lineItem;
            }
            else {
                if (layoutItem._) {
                    address = address + layoutItem._;
                }
            }
        })));
};
exports.default = GetAddress;
